import { createFileRoute } from "@tanstack/react-router";
import { heritageCityRoute } from "@/lib/seo/heritageCityRoute";

export const Route = createFileRoute("/heritage/stockholm")(
  heritageCityRoute({
    citySlug: "stockholm",
    angle:
      "I Stockholm möter vi både familjer som vill bevara en närståendes berättelse och företag som behöver dokumentera grundarresor, seniora medarbetares erfarenhet och organisationens kultur innan kunskapen försvinner.",
    localUseCases: [
      "Filmad intervju med förälder eller morförälder hemma",
      "Grundarporträtt för SaaS- och tech-bolag",
      "Kunskapsöverföring inför pension i konsultbolag",
      "Företagshistoria och kulturdokumentation",
      "Generationsskifte i ägarledda Stockholmsbolag",
      "Minnesfilm för familjer i Storstockholm",
    ],
  }),
);
